module.exports = {"content":{},"productInfo":{"code":"{B61EA01B-639A-4648-8F33-C7F9881034DA}","name":"イタリア語　初中級","serialHead":"ZTXMM","courseResourceIDs":[{"levelNo":1,"resourceID":"b29d5d32e3fcc4656648f01982280129c66e293a"},{"levelNo":2,"resourceID":"7e090f334bd86b6738da0a9e4ac6265ed5af8c1e"},{"levelNo":3,"resourceID":"936a9bc6c70539d7496a2c9f540a4ea1a119ff11"},{"levelNo":4,"resourceID":"6d145f7c64a04569c8d510c41194df01368f25c1"},{"levelNo":5,"resourceID":"1774e5a1b5d7d595cd91db034c3d0ec7e557badc"}],"language":"it-IT","challengeCount":34010},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1